export default __webpack_public_path__ + "media/images/logo_full-d06dd55dd3b4bc2b6dec2a3a50ab91f0.svg";